var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('PublicHeader'),_c('div',{style:({ paddingTop: '60px', height: '100%' })},[_c('router-view')],1),_c('PublicFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }